import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
};

export default ProtectedRoute;
